import { useState, useMemo } from "react";
import { FolderKanban, Plus, Search } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, ProjectCard, DemoBadge, AsyncBoundary, CardSkeleton } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CreateResourceDialog } from "@/components/common/CreateResourceDialog";
import { demoAction } from "@/lib/demo";

export default function Projects() {
  const { data, loading, error, reload } = useAsync(() => api.getProjects());
  const [q, setQ] = useState("");
  const rows = useMemo(() => (data || []).filter((p) => !q || `${p.name} ${p.client} ${p.stack}`.toLowerCase().includes(q.toLowerCase())), [data, q]);

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader
        icon={FolderKanban}
        title="Projetos"
        description="Aplicações e serviços gerenciados. Cada projeto pode conter múltiplos serviços, domínios e servidores."
        breadcrumb={<><span>Organização</span><span>/</span><span className="text-foreground">Projetos</span></>}
        actions={<>
          
          <CreateResourceDialog kind="projects" onCreated={reload} />
        </>}
      />

      <div className="relative max-w-md">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar projeto..." data-testid="projects-search" className="border-line bg-surface pl-9" />
      </div>

      <AsyncBoundary loading={loading} error={error} skeleton={<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">{Array.from({ length: 6 }).map((_, i) => <CardSkeleton key={i} />)}</div>}>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {rows.map((p) => <ProjectCard key={p.id} project={p} />)}
        </div>
      </AsyncBoundary>
    </div>
  );
}
